import {isArraysSame, defineDiffDeepArray, onlyInTargetArray, unionArray} from '@/utils/array'
import Vue from 'vue'


/**
 * @param {{[key: string]: any}} originalObject
 * @param {{[key: string]: any}} currentObject
 * @returns {boolean}
 */
export const isObjectsSame = (originalObject, currentObject) => {
  // let hasChange = false

  if(isObject(currentObject) && isObject(originalObject)){

    const currentMap = new Map(Object.entries(currentObject)) 
    const originalMap = new Map(Object.entries(originalObject)) 

    if( currentMap.size !== originalMap.size) return false;
    return [...originalMap.entries()].every(([key, value]) => {
      if(currentMap.has(key)){
        if(Array.isArray(currentMap.get(key))){
          return isArraysSame(currentMap.get(key), value)
        }else{
          return currentMap.get(key) === value
        }
      }
    });

    // Object.getOwnPropertyNames(currentObject).forEach(objProperty => {

    //   if(originalObject[objProperty] !== currentObject[objProperty] ) hasChange = true;

    //   // if(isObject(currentObject[objProperty])){

    //   //   if(isObjectsSame(originalObject[objProperty], currentObject[objProperty])) hasChange = true; 

    //   // }else if( Array.isArray(currentObject[objProperty])){

    //   //   if( isArraysSame(originalObject[objProperty], currentObject[objProperty]))  hasChange = true;

    //   // }else{
        
    //   //   if(originalObject[objProperty] !== currentObject[objProperty] ) hasChange = true;
        
    //   // }
    // })
  }else {
    console.warn(" Something went wrong in isObjectsSame function =>  originalObject and currentObject both of them should be Object");
    return false
  }

  //  return !hasChange
}


/**
 * @param {{[key: string]: any}} object
 * @returns {boolean}
 */

export const isEmpty = (object) => { return  !!object && Object.keys(object).length === 0; }

/**
 * @param {{[key: string]: any}} object
 * @returns {boolean}
 */
export const isObject = (object) => {  return object instanceof Object && !Array.isArray(object) }

/**
 * @param {{[key: string]: any}} obj
 * @param {string} prefix
 * @returns {{[key: string]: any}}
 */

export const deepFlattenToObject = (obj, prefix = '') => {
  return Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '_' : '';
    if (typeof obj[k] === 'object' && obj[k] !== null) {
      Object.assign(acc, deepFlattenToObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});
}
/**
 * find same key in two object and return array of keys 
 * @param {{[key: string]: any}} firstObj
 * @param {{[key: string]: any}} secondObj
 * @returns {string[]}
 */

export const findSameKeysObj = (firstObj, secondObj)=> {
  let  finalObj = new Array()
  for(const objProperty in firstObj){
    if( Object.hasOwn(secondObj, objProperty)) finalObj.push(objProperty)
  }

  return finalObj
}
/**
 * get Difference objects 
 * @param {{[key: string]: any}} original
 * @param {{[key: string]: any}} updated
 * @returns {{[key: string]:{ ['old']:any, ['new']: any}}}
 */
export const getDifference = (original, updated) => {
  const difference = {}
  for(const field in original) {
    if(original[field] && updated[field] && original[field] !== updated[field]) {
        if(original[field] !== null && typeof original[field] === 'object' && !Array.isArray(original[field]) && !Array.isArray(updated[field])) {
            const objDiff = getDifference(original[field], updated[field]);
            for(const objField in objDiff) {
                difference[field + objField.toTitleCase()] = objDiff[objField]
            }
        } else if (Array.isArray(original[field])) {
            let isDifferent = false;
            for (let index = 0; index < (original[field]).length; index++) {
                if(original[field][index] !== updated[field][index]) isDifferent = true;
            }
            if(isDifferent) difference[field] = {old: [...original[field] ], new: [...updated[field] ]}
        } else {
            difference[field] = {old: original[field], new: updated[field]}
        }
    } else if((!original[field] || !updated[field]) && original[field] !== updated[field]) {
        difference[field] = {old: original[field], new: updated[field]}
    }
  }
  return difference;
}
/**
 * @param {{[key: string]: any}} dataModel
 * @returns {{[key: string]: any}}
 */
export const getModelDifference = (dataModel)=>{
  const cloneUpdatedModel= cloneDeep(dataModel) 
  const pureUpdatedModel= extractPureDataObject(cloneUpdatedModel)

  const cloneOriginalModel = cloneDeep(dataModel.__proxy__.originalValues) 
  const pureOriginalDataModel =  extractPureDataObject(cloneOriginalModel)

  const dirtyObj = cloneUpdatedModel.__proxy__.dirty

  const diffObj =  getDifference(pureOriginalDataModel,pureUpdatedModel)

  const modelDiff =  Object.entries(diffObj).reduce((accumulator,[key, value])=>{
    if(dirtyObj[key]){

      if(Array.isArray(diffObj[key].new)){
        const value = defineDiffDeepArray(diffObj[key].old, diffObj[key].new )
        return Object.assign({[key]: value }, accumulator) 
      }else{
        return Object.assign({[key]: diffObj[key].new }, accumulator) 
      }
    }else{
      return accumulator
    }
  }, {ID: cloneUpdatedModel.ID}) 
  

  return modelDiff

}
/**
 * @param {T} dataModel
 * @returns {T}
 */
export const cloneDeep = (dataModel)=>{
  return deepCopy(dataModel)
}

export function deepCopy(value, copied = []) {
  if (!value) return value;
  else if (Array.isArray(value)) return value.map(deepCopy, copied);
  else if (typeof value === "object") {
    if (copied === 0) {
      copied = []
    }
    if (!copied && !copied.includes(value)) {
      const v = Object.keys(value)
        .filter((k) => k !== "__proxy__")
        .reduce(
          (o, k) => ({ [k]: this.deepCopy(value[k], copied), ...o }),
          {}
        );
      copied.push(v);
      return v;
    } else return value;
  } else return value;
}

/**
 * @param {{[key: string]: any}} dataModel
 * @returns {{[key: string]: any}}
 */
export const extractPureDataObject = (dataModel) => {
  return Object.fromEntries(Object.entries(dataModel).filter(([key, value]) => {
    return !key.startsWith("__") && typeof value !== "function" && value !== null
  }))

}


/**
 * Description
 * @param {object} target
 * @param {Object} source
 * @returns {Object}
 */
export const reactiveUpdateObject = (target, source)=>{
  if (source){
    for (let k of Object.keys(source)) Vue.set(target, k, source[k]);
  }
  return target;
}

/**
 * updateDifferentTypeObject
 * @param {Object} target
 * @param {Object} src
 * @returns {object}
 */

export const updateDifferentTypeObject = (target, src)=> {
  const res = {};
  Object.keys(target)
        .forEach(k => res[k] = (src[k] ?? target[k]));
  return res;
}

export const removeNullProperty =  async (response)=>{
  const cloneResponse= cloneDeep(response)
  if(isObject(response)){
    Object.keys(response).forEach(async(responseKey)=>{
      if(response[responseKey] === null){
        await delete cloneResponse[responseKey]
      }
    })
  }

  return cloneResponse
}